import { IFaq, IStudentDemand } from '@/study-search/interfaces';
import { FaqHandler } from './FaqHandler';
import { ParameterType } from '@/study-search/enums';
import studentDemandData from './data/student-demand.json';

export class DisciplineCountryFaqHandler extends FaqHandler {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length >= 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected async handle(): Promise<IFaq[]> {
		const countryFilterOption = this.getFilterOption(ParameterType.COUNTRY);
		const disciplineFilterOption = this.getFilterOption(ParameterType.DISCIPLINES);

		if (!countryFilterOption || !disciplineFilterOption) {
			throw new Error('Filter option not found.');
		}

		const faqs = [] as IFaq[];
		const studentDemand = this.getStudentDemandInfo(
			Number(disciplineFilterOption.optionValue),
			Number(countryFilterOption.optionValue)
		);
		if (studentDemand) {
			const { discipline_name, country_name, supply_demand, interest, interest_trend, programme_amount } =
				studentDemand;

			faqs.push({
				question: `What is the student demand for a ${discipline_name} Master’s in ${country_name}?`,
				answer: `
				<div>Master’s programmes in ${discipline_name} in ${country_name} are currently ${supply_demand}, 
					according to Studyportals data for the past 12 months. The interest amongst students for pursuing a Master's 
					in ${discipline_name} in ${country_name} is ${interest}, and ${interest_trend} in the past year.
					Additionally, ${country_name} offers ${programme_amount} programmes in this discipline.
				</div>`
			});
		}

		return faqs;
	}

	private getStudentDemandInfo(disciplineId: number, countryId: number): IStudentDemand | undefined {
		const studentDemand = studentDemandData.find((_) => _.discipline_id === disciplineId && _.country_id === countryId);

		return studentDemand;
	}
}
